import React from "react";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { formatoMexico } from "../../../../config/reuserFunction";
import moment from "moment";
import DehazeIcon from "@mui/icons-material/Dehaze";
import { Box, Typography } from "@mui/material";
import { CheckCircleTwoTone, ErrorTwoTone } from "@mui/icons-material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DetallePagoModal({ sale }) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <IconButton
        size="small"
        variant="outlined"
        color="inherit"
        onClick={handleClickOpen}
      >
        <DehazeIcon />
      </IconButton>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="dialog-detalles-payment"
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle id="dialog-detalles-payment">Datalle de pago</DialogTitle>
        <DialogContent>
          <TablaVentaComponent sale={sale} />
          <Box mt={2}>
            <Box my={2}>
              <Typography variant="h6">Detalle de la compra</Typography>
            </Box>
            {sale.courses.length ? (
              <TablaCursosComponent sale={sale} />
            ) : (
              <TablaServiceComponent sale={sale} />
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const TablaVentaComponent = ({ sale }) => {
  return (
    <TableContainer component={Paper}>
      <Table size="small" stickyHeader aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell width={100}>Fecha</TableCell>
            <TableCell width={260}>Nombre comprador</TableCell>
            <TableCell width={150}>Método de pago</TableCell>
            <TableCell width={150}>Estado de pago</TableCell>
            <TableCell width={160}>Servicio adquirido</TableCell>
            <TableCell>Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{moment(sale.createdAt).format("DD/MM/YYYY")}</TableCell>
            <TableCell>{sale.nameUser}</TableCell>
            <TableCell>{sale.typePay}</TableCell>
            <TableCell>
              <span style={{ display: "flex" }}>
                {sale.statusPay ? (
                  <CheckCircleTwoTone
                    htmlColor="green"
                    style={{ fontSize: 20 }}
                  />
                ) : (
                  <ErrorTwoTone color="error" style={{ fontSize: 20 }} />
                )}
                <Typography variant="body2" style={{ marginLeft: 6 }}>
                  {sale.comment}
                </Typography>
              </span>
            </TableCell>
            <TableCell>
              {sale.typeService ? sale.typeService : "Curso"}
            </TableCell>
            <TableCell>$ {formatoMexico(sale.total)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const TablaCursosComponent = ({ sale }) => {
  return (
    <TableContainer component={Paper}>
      <Table size="small" stickyHeader aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Curso</TableCell>
            <TableCell>Precio del curso</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sale.courses.map((curso, index) => (
            <TableRow key={index}>
              <TableCell>{curso.idCourse.title}</TableCell>
              <TableCell>
                ${" "}
                {formatoMexico(
                  curso.pricePromotionCourse
                    ? curso.pricePromotionCourse
                    : curso.priceCourse
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const TablaServiceComponent = ({ sale }) => {
  const { idService } = sale;
  if (!idService) {
    return (
      <Box>
        <Typography color="textSecondary">No hay detalles </Typography>
        <Typography color="textSecondary" variant="body2">
          Probablemente este pago fue realizado mediante los enlaces de pago
          con el tipo de artículo "otro" y no esta relacionado a un producto de
          Uniline
        </Typography>
        
      </Box>
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table size="small" stickyHeader aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Nombre servicio</TableCell>
            <TableCell>Descripción</TableCell>
            <TableCell>Tipo</TableCell>
            <TableCell>Precio</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{idService.name ? idService.name : ""}</TableCell>
            <TableCell>
              {idService.description ? idService.description : ""}
            </TableCell>
            <TableCell>{idService.type ? idService.type : ""}</TableCell>
            <TableCell>
              ${idService.price ? formatoMexico(idService.price) : ""}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
